import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*() {
  return yield oncallFetch("/api/oncall/partners/users/list", {});
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/users/list.js